module.exports = __webpack_public_path__ + "static/loader-2858286166adb62ac6b4d545c372c2e0.mp4";